import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import customerKeys from '@/api/queries/customers/keyFactory';
import { graphql } from '@/gql';

const GetCustomerContactEmailsQuery = graphql(`
  query ExistingCustomerContactEmails {
    existingCustomerContactEmails
  }
`);

const useGetExistingCustomerContactEmails = (customerId?: string) => {
  const { data, ...rest } = useQuery({
    queryKey: customerKeys.existingCustomerContactEmails,
    queryFn: () => {
      return gqlClient.request(GetCustomerContactEmailsQuery);
    },
  });

  return {
    data: data?.existingCustomerContactEmails,
    ...rest,
  };
};

export default useGetExistingCustomerContactEmails;
